import type { FormSchema, WidgetType } from './gb-api';

/*
 * temporary, will pull from widgets-core package in fast follow
 * https://linear.app/givebutter/issue/GRO-777
 */
const WIDGET_DEFAULTS: Record<WidgetType, Record<string, unknown>> = {
  button: {
    type: 'static',
    label: 'Donate',
    labelColor: '#FFFFFF',
    icon: 'heart',
    iconPosition: 'left',
    borderRadius: 24,
    borderColor: '',
    borderWidth: 0,
    dropShadow: true,
    position: 'bottom-right',
  },
  'giving-form': {
    showGoalBar: false,
  },
  'goal-bar': {
    type: 'progress-bar',
    size: 'md',
    showGoalAmount: true,
    showAmountRaised: true,
    showRaisedPercentage: true,
    padding: 16,
    textColor: '#000000',
    borderColor: '#E2E4E5',
    borderWidth: 1,
    borderRadius: 10,
    backgroundColor: '#FFFFFF',
  },
  'signup-form': {
    type: 'static',
    openDelay: 5000,
    layout: 'simple',
    channel: 'email',
    title: 'Subscribe for updates',
    description: 'Join our newsletter and get the latest updates.',
    borderRadius: 24,
    buttonText: 'Subscribe',
    buttonTextColor: '#FFFFFF',
    imageSizing: 'stretch',
    isFirstAndLastNameRequired: true,
  },
};

export const defaultsFromSchema = (
  type: WidgetType,
  schema: FormSchema,
): Record<string, unknown> => {
  const config: Record<string, unknown> = {};
  for (const [key, entry] of Object.entries(schema)) {
    config[key] = WIDGET_DEFAULTS[type][key] ?? entry.default ?? null;
  }
  return config;
};

export const sanitizeConfig = (
  type: WidgetType,
  config: Record<string, unknown>,
): Record<string, unknown> => {
  if (type === 'button' && config?.type !== 'floating') {
    return { ...config, position: '' };
  }
  return config;
};

export const configWithDefaults = (
  type: WidgetType,
  schema: FormSchema,
  saved: Record<string, unknown> | undefined,
): Record<string, unknown> => {
  const present = Object.entries(saved ?? {}).filter(([, value]) => value != null);
  return { ...defaultsFromSchema(type, schema), ...Object.fromEntries(present) };
};

export const WIDGET_TYPE_LABELS: Record<WidgetType, string> = {
  button: 'Donate button',
  'giving-form': 'Giving form',
  'goal-bar': 'Goal bar',
  'signup-form': 'Signup form',
};
